import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const ModalExclusaoGerente = ({
  open = false,
  onClose = () => {},
  onConfirm = () => {},
  gerente = null,
  usuarioNome = "",
  loading = false,
  success = false,
  errorMessage = "",
}) => {
  const [justificativa, setJustificativa] = useState("");

  useEffect(() => {
    if (open) {
      setJustificativa("");
    }
  }, [open, gerente]);

  const handleConfirm = () => {
    if (!justificativa.trim()) return;
    onConfirm(justificativa.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          bgcolor: "#ffe8e8",
          color: "#8a1f1f",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        Confirmar Exclusão
      </DialogTitle>
      <DialogContent sx={{ mt: 2, position: "relative" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              bgcolor: "rgba(255,255,255,0.75)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
              gap: 1.5,
              borderRadius: 1,
            }}
          >
            <CircularProgress size={32} />
            <Typography variant="body2" sx={{ color: "#444" }}>
              Excluindo gerente...
            </Typography>
          </Box>
        )}
        <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
          {(usuarioNome || "Usuario")} tem certeza que deseja excluir o gerente "{gerente?.nome || "-"}"?
        </Typography>
        <TextField
          label="Justificativa de Exclusão"
          placeholder="Descreva o motivo da exclusão deste gerente."
          value={justificativa}
          onChange={(e) => setJustificativa(e.target.value)}
          fullWidth
          multiline
          rows={3}
          required
          sx={{ mt: 2 }}
        />
        {errorMessage && (
          <Alert severity="error" variant="outlined" sx={{ mt: 2 }}>
            {errorMessage}
          </Alert>
        )}
        {success && (
          <Alert severity="success" variant="outlined" sx={{ mt: 2 }}>
            Gerente excluido com sucesso.
          </Alert>
        )}
      </DialogContent>
      <Box sx={{ p: 2, display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ textTransform: "none" }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading || success || !justificativa.trim()}
          sx={{ textTransform: "none", minWidth: 140 }}
        >
          {loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CircularProgress size={16} sx={{ color: "white" }} />
              <span>Excluindo...</span>
            </Box>
          ) : (
            "Excluir Gerente"
          )}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ModalExclusaoGerente;
